// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1dyqf","colMin":"styles_colMin__1LNvO","colCheckbox":"styles_colCheckbox__ntOsY"};